import * as types from './coreActionTypes';
import { CoreActionKeys as keys } from './coreActionKeys';

export const coreActionCreators = {
  appInitialized: (): types.AppInitialized => ({ type: keys.APP_INITIALIZED }),
  initApp: (): types.InitApp => ({ type: keys.INIT_APP })
};
